import React from 'react';
import {Link} from "react-router-dom";

function ServiceItem(props) {
    const serviceURL = `/service/${props.title.split(' ').join('-').toLowerCase()}/${props.id}`
    return (
        <div className="col-sm-6 col-lg-4" style={{marginBottom:"2.5%"}}>

            <div style={{
                maxHeight:"200px",
                maxWidth:"200px",
                minHeight:'120px',
                minWidth:'120px',
                borderRadius:'50%',
                backgroundImage:`url(${process.env.REACT_APP_BASE_URL + props.thumb})`,
                position:"absolute",
                top:'-13%',
                right: '37%',
                backgroundColor:"#fff",
                zIndex:'100000',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                // border:"1px solid #e5e5e5"
            }}/>
            <div className="service-item">
                {/* <div style={{width:'8%', height:"8px", backgroundColor:'red', margin:"auto"}}/> */}
                <figure className="service-thumb">
                    

                    <figcaption className="service-txt">
                        <h5>{props.title}</h5>
                        <p dangerouslySetInnerHTML={{__html: props.text}}/>
                    </figcaption>
                </figure>
                {/* <div className="service-content">
                    <div className="service-content-inner">
                        <h5>
                            <Link to={`${localhost:3000 + serviceURL}`} className="stretched-link">{props.title}</Link>
                        </h5>
                    </div>
                </div> */}
            </div>
        </div>
    );
}

export default ServiceItem;